import { HttpClient } from '@opallabs/api'
import loadStoryCSVRowCount from '../loadStoryCSVRowCount'

// update with accurate request when available
const fetchCount = ({
  brand_id,
  label_ids = [],
  scheduled_start_at,
  scheduled_end_at,
}) =>
  HttpClient().get('/stories/v2', {
    params: {
      'filter[brand_id]': brand_id,
      'filter[label_ids]': label_ids,
      'filter[scheduled_start_at]': scheduled_start_at,
      'filter[scheduled_end_at]': scheduled_end_at,
    },
  })

const getStoryCSVRowCount = (params) => (dispatch) =>
  fetchCount(params)
    .then((response) => dispatch(loadStoryCSVRowCount(response.data)))
    .catch((err) => {
      console.log(err)
      throw err
    })

export default getStoryCSVRowCount
